<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-align: center;">I’d like to thank Austin Macauley Publishers for providing me with this opportunity.</p><br/>
<p style="text-align: center;">I’d also like to thank those who believe in me; my mum and dad along with Peter, Jacqueline, Joseph and Ellie.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?ee3914b8